import { render } from "./ComponenteSOS.vue?vue&type=template&id=5556b8ca&scoped=true"
import script from "./ComponenteSOS.vue?vue&type=script&lang=js"
export * from "./ComponenteSOS.vue?vue&type=script&lang=js"

import "./ComponenteSOS.vue?vue&type=style&index=0&id=5556b8ca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sebastian\\Documents\\choferes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5556b8ca"]])

export default __exports__